import BaseSetup from '@/components/BaseSetup';
import usePersonalInformationService from '@/services/PersonalInformationService';
import { Reactive } from '@/utils/decorators';
import { regexName } from '@/utils/tools';
import { useValidation } from '@orion.ui/orion';
import { ref } from 'vue';

export type ModalTempWorkerInfosEmits = {};
export type ModalTempWorkerInfosProps = {
	resolve?: (value: boolean | IPersonalInformationModel) => void
	fieldToFocus?: 'PhoneNumber' | 'FirstName' | 'LastName'
};

export default class ModalTempWorkerInfosSetup extends BaseSetup {

	static readonly defaultProps = {};

	readonly _FirstName = ref<OrionInput>();
	readonly _LastName = ref<OrionInput>();
	readonly _PhoneNumber = ref<OrionPhone>();

	private dbUserInfos?: IPersonalInformationModel;
	private readonly regexName = regexName;
	@Reactive private readonly state = {
		phone: {
			phoneCountryCode: undefined as Undef<string>,
			phoneNumber: undefined as Undef<string>,
		},
		userFirstName: '',
		userLastName: '',
		mobilePhone: undefined as Undef<string>,
		mobilePhoneCountry: 'FR' as Undef<string>,
	};

	readonly validator = useValidation(this.state, {
		userFirstName: () => this.regexName.test(this.state.userFirstName),
		userLastName: () => this.regexName.test(this.state.userLastName),
		phone: 'required|phone:mobile',
	});

	get phone () { return this.state.phone }
	set phone (val) {
		this.state.phone = val;
		this.state.mobilePhone = val.phoneNumber;
		this.state.mobilePhoneCountry = val.phoneCountryCode;
	}

	get firstName () { return this.state.userFirstName }
	set firstName (val) { this.state.userFirstName = val }

	get lastName () { return this.state.userLastName }
	set lastName (val) { this.state.userLastName = val }

	constructor (
		private props: ModalTempWorkerInfosProps,
		private emits: ModalTempWorkerInfosEmits,
		private _modal?: OrionModal,
	) {
		super();
	}

	protected onMounted () {
		this._modal?.bus.on('enter-end', () => {
			if (this.props.fieldToFocus) {
				this[`_${this.props.fieldToFocus}`].value?.focus();
			}
		});

		this.initDataAsync();
	}

	private async initDataAsync () {
		this._modal?._loader()?.show(this.$t('user.loadingInformation'));

		const data = await usePersonalInformationService().getAsync();
		this.dbUserInfos = data;
		Object.assign(this.state, data);

		this._modal?._loader()?.hide();
	}

	cancel () {
		this.props.resolve?.(false);
		this._modal?.close();
	}

	async saveAsync () {
		if (!this.validator.validate()) {
			this.validator.showValidationState();
			return;
		}

		this._modal?._loader()?.show(this.$t('user.savingInformation'));

		if (this.dbUserInfos?.id) {
			const data = await usePersonalInformationService().updateAsync(
				this.dbUserInfos.id,
				{
					...this.dbUserInfos,
					...this.state,
				},
			);

			if (data) {
				this.self.assignData({
					firstName: data.userFirstName,
					lastName: data.userLastName,
				});
				this._modal?.close();
				this.props.resolve?.(data);
			}
			else {
				this._modal?._loader()?.hide();
			}
		}
	}

}
